/**
 * Forfait (billing package) requirements.
 * Each package defines the MINIMUM officials needed to fulfill it.
 *
 *  A = 1 arbitre, 0 marqueur
 *  B = 2 arbitres, 0 marqueur
 *  C = 1 arbitre, 1 marqueur
 *  D = 2 arbitres, 1 marqueur
 */
export const PACKAGE_REQUIREMENTS = {
  A: { refs: 1, scorer: 0 },
  B: { refs: 2, scorer: 0 },
  C: { refs: 1, scorer: 1 },
  D: { refs: 2, scorer: 1 },
};

/**
 * Returns true if the game's assignments meet the requirements of the chosen package.
 *
 * - If package_override is set → use that package's requirements
 * - If no override and game has no assignments → incomplete (we can't infer intent)
 * - If no override and some assignments → use default expectation = D (2 refs + 1 scorer).
 *   This matches the historical behavior (line was blue when missing a ref).
 */
export function isPackageFulfilled(game) {
  if (!game || game.is_break) return true;
  const refs = (game.referee1_id ? 1 : 0) + (game.referee2_id ? 1 : 0);
  const sc = game.scorer_id ? 1 : 0;
  const pkg = game.package_override;
  if (pkg && PACKAGE_REQUIREMENTS[pkg]) {
    const req = PACKAGE_REQUIREMENTS[pkg];
    return refs >= req.refs && sc >= req.scorer;
  }
  // Default expectation when admin hasn't picked a package: full crew (D)
  return refs >= 2 && sc >= 1;
}

/**
 * Inverse helper for highlighting incomplete games (blue line in schedule).
 */
export function isPackageIncomplete(game) {
  return !isPackageFulfilled(game);
}
